import { IAsset } from '../types/assets.type';
import $http from '../services/AxiosInstance';

interface Params {
  page?: number;
  search?: string;
  riskType?: string;
  companyName?: string;
  deleted?: boolean;
}

class AssetsRepository {
  static async getAssetsPublic() {
    try {
      const response = await $http.get('/assets');
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }
  static async getAssetsAll() {
    try {
      const response = await $http.get('/assets/all');
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }
  static async getAssets(params: Params = {}) {
    try {
      let url = `/assets/pro`;
      if (params.page) {
        url += `?page=${params.page}`;
      }
      if (params.search) {
        url += `&search=${params.search}`;
      }
      if (params.riskType) {
        url += `&riskType=${params.riskType}`;
      }
      if (params.companyName) {
        url += `&companyName=${params.companyName}`;
      }
      if (params.deleted) {
        url += `&deleted=${params.deleted}`;
      }
      const response = await $http.get(url);
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }
  static async createAsset(data: IAsset): Promise<IAsset> {
    try {
      const response = await $http.post('/assets', data);

      return response.data;
    } catch (error) {
      throw Error;
    }
  }
  static async updateAsset(data: IAsset): Promise<IAsset> {
    try {
      const response = await $http.patch(`/assets/${data.id}`, data);
      return response.data;
    } catch (error) {
      throw Error;
    }
  }
  static async deleteAsset(id: number): Promise<number> {
    try {
      const response = await $http.delete(`/assets/${id}`);
      return response.status;
    } catch (error) {
      throw Error;
    }
  }
  static async restoreAsset(id: number): Promise<number> {
    try {
      const response = await $http.post(`/assets/restore/${id}`);
      return response.status;
    } catch (error) {
      throw Error;
    }
  }
}

export default AssetsRepository;
